import { useContext } from 'react';

import ScriptContext from '../context/Script';
import ProjectViewContext from '../context/ProjectView';

// Expands or collapses every shot card in the selected scene and records the
// choice in view.expandShots, so it's re-applied when another scene is opened
// (see ShotTable). Shared by ShotTable and the Shots toolbar control.
const useExpandAllShots = () => {
  const { script, setScript } = useContext(ScriptContext);
  const { view, setView } = useContext(ProjectViewContext);

  return function expandAll(expand) {
    if (view.sceneIndex === null) return;
    const currentScene = script.scenes[view.sceneIndex];
    if (!currentScene || !currentScene.shot_list || currentScene.shot_list.length === 0) return;

    const updatedSceneList = script.scenes.map((scene, index) => {
      if (index === view.sceneIndex) {
        const updatedShotList = scene.shot_list.map((shot) => ({
          ...shot,
          expanded: expand,
        }));
        return {
          ...scene,
          shot_list: updatedShotList,
        };
      }
      return scene;
    });

    setView((prevView) => ({
      ...prevView,
      expandShots: expand,
    }));

    setScript((prevScript) => ({
      ...prevScript,
      scenes: updatedSceneList,
    }));
  };
};

export default useExpandAllShots;
